import React from 'react';
import { Link } from 'react-router';
import moment from 'moment';
import { Animated } from "react-animated-css";

// August 7th: refactored for responsiveness
const Tournament = ({ hideLink = false, tournament }) => {
    return (
        <Animated animationIn="fadeIn" style={{ position: 'relative' }} className={`d-flex flex-row pt-4 pb-4 ease tournament-card ${tournament.Suspended ? '' : ''}`}>
            {tournament && tournament.id && (
                <div className="align-self-center text-center" style={{ width: 200, position: 'relative' }}>
                    <img alt="" className="align-self-center m-auto" src={`${tournament.Affiliate ? tournament.Affiliate.Logo : "/images/cs_logo.png"}`}
                        style={{ maxWidth: 120, maxHeight: 100 }} />                    
                </div>)}            

            {tournament && tournament.id && (<div className="w-100 d-flex row-column justify-content-center" style={{ borderLeft: '1px solid gray' }}>
                <div className="w-100 align-self-center justify-content-left pt-2 pb-2 pl-4 pr-4 d-flex flex-row" style={{ position:  'relative' }} >
                    <div className="d-flex flex-column justify-content-left">
                        <span className="font-14 hind toBold" style={{ lineHeight: 1 }} >{moment(tournament.DateStart).utc().format('MMM Do')}{(tournament.DateEnd && moment(tournament.DateEnd).isAfter(moment(tournament.DateStart))) ? (moment(tournament.DateStart).format('MMM') === moment(tournament.DateEnd).format('MMM') ? moment(tournament.DateEnd).format(' - Do, YYYY') : moment(tournament.DateEnd).format(' - MMM Do, YYYY')) : moment(tournament.DateStart).format(', YYYY')}</span>
                        <span className="font-12 gray hind margin-top-half" style={{ lineHeight: 1 }} >{tournament.Name}</span>                        
                    </div>
                    {tournament.Medal && tournament.Medal.id && <span className="font-10 gray hind margin-top" style={{ lineHeight: 1, position: 'absolute', bottom: -25, left: 23 }} >Passport Medal: <b>{tournament.Medal.Name}</b></span>}
                </div>
                <div className="w-100 align-self-center text-center d-flex flex-row justify-content-left pt-2 pb-2 pl-4 pr-4">
                    <i className="fas fa-map-marker-alt red margin-right-half font-16" />
                    <div className="d-flex flex-column justify-content-left font-10">
                        <span className="hind black toBold align-self-start text-left">{tournament.LocationName}</span>
                        <span className="hind gray align-self-start text-left" style={{ lineHeight: 1 }}>{tournament.LocationAddress}</span>
                        <span className="hind gray align-self-start text-left block" style={{ lineHeight: 1 }}>{`${tournament.LocationCity}, ${tournament.LocationState} ${tournament.LocationZipCode}`}</span>                        
                    </div>
                </div>
                {!hideLink && <div className="w-100 align-self-center text-center w3-hide-small">
                    { tournament.Suspended !== 1 && <Link to={`/tournament/${tournament.id}`} className="w3-button bg-red white" style={{ borderRadius: 4 }}>VIEW DETAILS</Link> }
                    { tournament.Suspended === 1 && <h2 className="text-black text-center anton toBold">POSTPONED</h2> }
                </div>}
                {!hideLink && <div className="w-100 align-self-start w3-hide-medium w3-hide-large ml-4">
                    <Link to={`/tournament/${tournament.id}`} className="w3-button bg-red white" style={{ borderRadius: 4 }}>VIEW</Link>
                </div>}

                { false && <div style={{ position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}} className="d-flex flex-row justify-content-center">
                        <h1 className="text-black align-self-center anton toBold">POSTPONED</h1>
                    </div>}
            </div>)}

        </Animated>
    );
}

export default Tournament;



// WEBPACK FOOTER //
// ./src/components/tournaments/partials/tournament.js